<header>
  <nav class="navbar navbar-light p-0 pl-3">
    <a class="navbar-brand" routerLink="/"></a>
  </nav>
</header>
